/** @dokos: below this width (px) of the view, the modes switch to their mobile layout. */
export const MOBILE_WIDTH = 768;

/** @dokos: whether `element` is narrower than the mobile breakpoint. */
export function isMobileWidth(element) {
	const width = element?.getBoundingClientRect().width;
	return Boolean(width) && width < MOBILE_WIDTH;
}

/** @dokos: the session user's employee, fetched once (a user without one is cached too). */
let myOwnEmployee = null;
let overridenEmployee = "";

export async function getCurrentEmployee() {
	if (overridenEmployee) {
		return overridenEmployee;
	}
	if (!myOwnEmployee) {
		myOwnEmployee = frappe.db
			.get_value("Employee", { user_id: frappe.session.user }, "name")
			.then((res) => res?.message?.name)
			.catch(() => {
				myOwnEmployee = null; // retry on the next call
			});
	}
	return myOwnEmployee;
}

export function viewAsAnotherEmployee(employee = "") {
	overridenEmployee = employee;
}

/** @dokos: the employee whose week is viewed instead of the user's own ("" when none). */
export function getOverriddenEmployee() {
	return overridenEmployee;
}

// @dokos: typed durations of the Log Time grid.
const DURATION_PATTERNS = [
	// "1:30"
	[/^(\d+):([0-5]?\d)$/, (m) => Number(m[1]) * 60 + Number(m[2])],
	// "1h", "1h30", "1h 30", "1h30m", "1.5h"
	[
		/^(\d+(?:\.\d+)?|\.\d+)\s*h(?:\s*([0-5]?\d)\s*(?:m|mn|min)?)?$/,
		(m) => Number(m[1]) * 60 + Number(m[2] || 0),
	],
	// "90m", "90 min", "90mn"
	[/^(\d+)\s*(?:m|mn|min)$/, (m) => Number(m[1])],
	// "1.5" (hours)
	[/^(\d+(?:\.\d+)?|\.\d+)$/, (m) => Number(m[1]) * 60],
];

/**
 * @dokos: minutes of a typed duration (pure function).
 *
 * | input                  | minutes |
 * |------------------------|---------|
 * | `""`, `"  "`           | 0       |
 * | `"1h"`                 | 60      |
 * | `"1h30"`, `"1h 30"`    | 90      |
 * | `"1h30m"`, `"1.5h"`    | 90      |
 * | `"1:30"`               | 90      |
 * | `"1.5"`, `"1,5"`       | 90      |
 * | `"90m"`, `"90min"`     | 90      |
 * | `"abc"`, `"1h75"`, `"-1"` | NaN  |
 *
 * @param {string|number|null|undefined} value
 * @returns {number} whole minutes, or NaN when the text is not a duration
 */
export function parseDuration(value) {
	const text = String(value ?? "")
		.trim()
		.toLowerCase()
		.replace(",", ".");
	if (!text) return 0;
	for (const [pattern, toMinutes] of DURATION_PATTERNS) {
		const match = text.match(pattern);
		if (match) return Math.round(toMinutes(match));
	}
	return NaN;
}

/**
 * @dokos: "6h", "5h30", "45m" (same format as the Plan mode chips).
 * @param {number} minutes
 */
export { formatMinutes as formatDuration } from "./PMRender";
